// ============================================================
// ByOurConsent.com -- Reset Password Page
// /reset-password/:token
// ============================================================

import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Nav    from '../components/Nav';
import Footer from '../components/Footer';
import api    from '../utils/api';
import toast  from 'react-hot-toast';

const ResetPasswordPage = () => {
    const { token }   = useParams();
    const navigate    = useNavigate();
    const [password,  setPassword]  = useState('');
    const [confirm,   setConfirm]   = useState('');
    const [loading,   setLoading]   = useState(false);
    const [error,     setError]     = useState('');

    const handleSubmit = async () => {
        if (!password) { setError('Please enter a new password'); return; }
        if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
        if (password !== confirm) { setError('Passwords do not match'); return; }

        setLoading(true);
        setError('');
        try {
            await api.post('/auth/reset', { token, password });
            toast.success('Password reset successfully!');
            navigate('/login');
        } catch (err) {
            setError(err.response?.data?.error || 'Reset link is invalid or expired. Please request a new one.');
        } finally {
            setLoading(false);
        }
    };

    const iStyle = {
        width: '100%', background: '#f5f0e8', border: '0.5px solid #c8beaa',
        padding: '10px 12px', fontSize: '13px', fontFamily: 'sans-serif',
        color: '#1e2a3a', borderRadius: '3px', outline: 'none', boxSizing: 'border-box'
    };

    return (
        <>
            <Helmet><title>Reset Password — By Our Consent</title></Helmet>
            <Nav />
            <div style={{ minHeight: '70vh', background: '#f5f0e8', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
                <div style={{ width: '100%', maxWidth: '420px' }}>
                    <div style={{ background: '#fff', border: '0.5px solid #c8beaa', borderRadius: '4px', padding: '2rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
                        <div style={{ fontSize: '24px', fontWeight: 600, color: '#1e2a3a', fontFamily: "'EB Garamond', Georgia, serif", marginBottom: '8px' }}>
                            Set new password
                        </div>
                        <div style={{ fontSize: '13px', fontFamily: 'sans-serif', color: '#6a7080', marginBottom: '1.5rem' }}>
                            Choose a strong password for your account.
                        </div>

                        <div style={{ marginBottom: '1rem' }}>
                            <label style={{ fontSize: '11px', fontFamily: 'sans-serif', color: '#6a7080', letterSpacing: '0.08em', textTransform: 'uppercase', display: 'block', marginBottom: '4px' }}>
                                New password
                            </label>
                            <input type="password" value={password}
                                onChange={e => setPassword(e.target.value)}
                                placeholder="At least 8 characters"
                                style={iStyle} />
                        </div>

                        <div style={{ marginBottom: '1.25rem' }}>
                            <label style={{ fontSize: '11px', fontFamily: 'sans-serif', color: '#6a7080', letterSpacing: '0.08em', textTransform: 'uppercase', display: 'block', marginBottom: '4px' }}>
                                Confirm new password
                            </label>
                            <input type="password" value={confirm}
                                onChange={e => setConfirm(e.target.value)}
                                onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                                placeholder="Repeat password"
                                style={iStyle} />
                        </div>

                        {error && (
                            <div style={{ background: '#fdf0ee', border: '0.5px solid #d4a8a0', borderRadius: '3px', padding: '10px 12px', fontSize: '13px', fontFamily: 'sans-serif', color: '#8b1a1a', marginBottom: '1rem' }}>
                                {error}
                                {error.includes('invalid or expired') && (
                                    <div style={{ marginTop: '6px' }}>
                                        <Link to="/forgot-password" style={{ color: '#8b1a1a', fontWeight: 600 }}>
                                            Request a new reset link →
                                        </Link>
                                    </div>
                                )}
                            </div>
                        )}

                        <button onClick={handleSubmit} disabled={loading}
                            style={{ width: '100%', background: '#8b1a1a', color: '#f5f0e8', border: 'none', padding: '11px', fontSize: '13px', fontFamily: 'sans-serif', letterSpacing: '0.06em', textTransform: 'uppercase', borderRadius: '3px', cursor: 'pointer', opacity: loading ? 0.6 : 1 }}>
                            {loading ? 'Resetting...' : 'Reset password →'}
                        </button>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default ResetPasswordPage;
